import { render, staticRenderFns } from "./create-new-password.html?vue&type=template&id=53bc54a6&scoped=true&external"
import script from "./create-new-password.js?vue&type=script&lang=js&external"
export * from "./create-new-password.js?vue&type=script&lang=js&external"
import style0 from "./create-new-password.scss?vue&type=style&index=0&id=53bc54a6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bc54a6",
  null
  
)

export default component.exports